import { Component } from '@angular/core';

interface FooterLink {
  label: string;
  path: string;
}

// Mirrors the thurrock.gov.uk footer menus
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  baseUrl = 'https://www.thurrock.gov.uk';

  servicesFirst: FooterLink[] = [
    { label: 'Adult care and health', path: '/adult-care-and-health' },
    { label: 'Business and licensing', path: '/business-and-licensing' },
    { label: 'Children and families', path: '/children-and-families' },
    { label: 'Community and living', path: '/community-and-living' },
    { label: 'Council and elections', path: '/council-and-elections' },
    { label: 'Education and learning', path: '/education-and-learning' },
    { label: 'Environment and safety', path: '/environment-and-safety' },
  ];

  servicesSecond: FooterLink[] = [
    { label: 'Housing', path: '/housing' },
    { label: 'Jobs and careers', path: '/jobs-and-careers' },
    { label: 'Leisure and culture', path: '/leisure-and-culture' },
    { label: 'Money, tax and benefits', path: '/money-tax-and-benefits' },
    { label: 'Planning and growth', path: '/planning-and-growth' },
    { label: 'Travel and transport', path: '/travel-and-transport' },
    { label: 'Waste and recycling', path: '/waste-and-recycling' },
  ];

  tasks: FooterLink[] = [
    { label: 'My account', path: '/my-account' },
    { label: 'Pay for it', path: '/pay' },
    { label: 'Report it', path: '/report' },
    { label: 'Apply for it', path: '/apply' },
    { label: 'Have my say', path: '/say' },
    { label: 'News', path: '/news' },
  ];

  infoLinks: FooterLink[] = [
    { label: 'Support', path: '/support' },
    { label: 'Accessibility', path: '/accessibility' },
    { label: 'Privacy', path: '/privacy' },
    { label: 'Terms', path: '/terms' },
    { label: 'Cookies', path: '/cookies' },
    { label: 'Contact us', path: '/contact' },
  ];

  social = [
    { label: 'Facebook', url: 'https://www.facebook.com/thurrockcouncil/', icon: 'assets/images/social/facebook.svg' },
    { label: 'Twitter', url: 'https://twitter.com/thurrockcouncil/', icon: 'assets/images/social/twitter.svg' },
    { label: 'Flickr', url: 'https://www.flickr.com/photos/thurrockcouncil/', icon: 'assets/images/social/flickr.svg' },
    { label: 'YouTube', url: 'https://www.youtube.com/thurrockcouncil', icon: 'assets/images/social/youtube.svg' },
  ];
}
